import Vue from "vue";
import Vuex from "vuex";

import templates from "./modules/templates";
import checklists from "./modules/checklists";
import auth from "./modules/auth";
import revision from "./modules/revision";
import exporter from "./modules/exporter";
import users from "./modules/users";
import checker from "./modules/checker";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    auth,
    exporter,
    checker,
    checklists,
    templates,
    revision,
    users,
  },
});
